import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//Material
import { MaterialModule } from './material/material.module';
import { ConfirmComponent } from './components/confirm/confirm.component';
import { LoaderComponent } from './components/loader/loader.component';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
     ],
    declarations: [
        ConfirmComponent,
        LoaderComponent,
    ],
    exports: [
        ConfirmComponent,
        MaterialModule,
        LoaderComponent
    ]
})
export class SharedModule {}
